import { makeAutoObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { InstitutionListResponse } from '../../../response/responseSchema';
import Box from '@client/uikit/Box';
import Frame from '@client/uikit/Frame';
import List from '@client/uikit/List';
import { apiClient } from '@app/apiClient';
import { useMobxInstance } from '@client/clientUtils/mobxUtil';
import Jsonld from '../Jsonld';
import MetaHeader from '@client/component/MetaHeader';

class ViewStore {
    institutionList: InstitutionListResponse = {
        items: [],
    };

    constructor() {
        makeAutoObservable(this);
    }

    async fetch() {
        const result = await apiClient.institution.public.getInstitutionList.$query();

        runInAction(() => {
            if (result) {
                this.institutionList = result;
            }
        });
    }
}

const PortfolioListPage = observer(() => {
    const viewStore = useMobxInstance(ViewStore);

    useEffect(() => {
        viewStore.fetch();
    }, [viewStore]);

    const title = '거장의 포트폴리오';
    const description =
        '13F 보고서를 기반으로 한 거장의 포트폴리오를 다양한 차트로 제공합니다. 거장들이 어느 곳에 얼마만큼 투자하고 있는지 시각적으로 쉽게 확인해보세요.';

    return (
        <Frame>
            <MetaHeader title={title} description={description} />
            <Jsonld type="Blog" title={title} description={description} />
            <Frame.Title title={title} />
            <Box>
                <List>
                    {viewStore.institutionList.items.map(({ institution, top1Holding }) => {
                        const top1Stock = top1Holding?.security?.stock;

                        return (
                            <List.Item
                                key={institution.hash}
                                link={`/portfolio/${institution.slug}`}
                            >
                                <div className="list-col-grow">
                                    <List.ItemTitle className="flex flex-row justify-between text-lg font-semibold tracking-tight">
                                        <div>{institution.keyPersonKo}</div>
                                        {top1Stock && (
                                            <div className="text-base-content/70 badge badge-soft badge-xs">
                                                {top1Stock.ticker}
                                            </div>
                                        )}
                                    </List.ItemTitle>
                                    <div className="text-base-content/70 mt-1 text-sm">
                                        {institution.nameKo}
                                    </div>
                                </div>
                            </List.Item>
                        );
                    })}
                </List>
            </Box>
            <Frame.BottomSpacer />
        </Frame>
    );
});

export default PortfolioListPage;
